const TimePeriod = {
  Unfiltered: 0,
  SinceBeginningOfYear: 1,
  LastMonth: 2,
  ThisMonth: 3,
  LastWeek: 4,
  ThisWeek: 5,
  Yesterday: 6,
  Today: 7,
  Hourly: 8,
};

export default TimePeriod;
